import { render, staticRenderFns } from "./PrismsUserSummaryPanel.vue?vue&type=template&id=7da004e1&"
import script from "./PrismsUserSummaryPanel.vue?vue&type=script&lang=js&"
export * from "./PrismsUserSummaryPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports